"use client";

import { useEffect } from 'react';
import Script from 'next/script';

// Declare google on the window object
declare global {
  interface Window {
    google: any;
    googleTranslateElementInit?: () => void;
  }
}

const GoogleTranslate = () => {
  useEffect(() => {
    // Function to get a cookie
    const getCookie = (name: string) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    }

    // If the cookie is not set, set it to Portuguese by default.
    // This prevents the widget from showing the "Original" language banner.
    if (!getCookie('googtrans')) {
        document.cookie = "googtrans=/pt/pt; path=/";
    }

    // Define the init function on the window object so the script can call it
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement({
          pageLanguage: 'pt',
          includedLanguages: 'en,es,pt,ru,it,de,fr',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false
        }, 'google_translate_element');
      }
    };
  }, []);

  return (
    <>
      <div id="google_translate_element" style={{ display: 'none' }}></div>
      <Script 
        id="google-translate-script"
        src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        strategy="afterInteractive"
      />
    </>
  );
};

export default GoogleTranslate;
